import type { GameAdapter, MatchSummaryPatch, PlayerId } from "../game-core";
import {
  activePlayer,
  createInitialState,
  isTerminal,
  legalMoves,
  reduce,
  validateMove,
  validateState,
  type GinMove,
  type GinState,
} from "./engine";

export const ginRummyAdapter: GameAdapter<GinState, GinMove> = {
  gameId: "gin-rummy",
  rulesVersion: "gin-rummy/1",
  displayName: "Gin Rummy",
  tagline: "First to 100. Make melds, shed deadwood.",

  createInitialState,
  validateState,
  legalMoves,
  validateMove,
  reduce,
  activePlayer,
  players: (state) => state.players,
  revision: (state) => state.revision,
  isTerminal,

  summarize(state: GinState, me: PlayerId): MatchSummaryPatch {
    const opp = state.players[0] === me ? state.players[1] : state.players[0];
    const myScore = state.match.points[me] ?? 0;
    const opponentScore = state.match.points[opp] ?? 0;
    if (isTerminal(state)) {
      const result = state.match.winnerId === me ? "won" : state.match.winnerId ? "lost" : undefined;
      return { myScore, opponentScore, status: "finished", result };
    }
    return { myScore, opponentScore, status: state.hand.activePlayerId === me ? "your-turn" : "waiting" };
  },
};
